export default __webpack_public_path__ + "static/media/AntyLucy_14.1a4a7a5b.jpg";